<p-dialog #utilsDialog header="Testing Utilities" [(visible)]="displayDialog" [modal]="false" [style]="{width: '1000'}" [focusOnShow]="false" [baseZIndex]="30000">

  <div class="row mb-3">
    <div class="col-12">
      <div class="col-1">
        Revisions:
      </div>
      <div class="col-10"> {{webappRevision}} (Deployed)<br>{{compiledInRevision}} (Client)</div>
    </div>
  </div>

  <p-tabView>
    <p-tabPanel [cache]="false" header="Websocket" style="min-width: 500; min-height: 500;">
      <ng-template pTemplate="content">
        <div class="tabcontent wide">
          <div>Send a message to the back end via websocket.</div>
          <input appScrText placeholder="Message Text" #messageInput>
          <input appScrText placeholder="Delay Seconds" type="text" #messageInputResponseDelay>
          <input appScrText placeholder="Message Size" #messageSize>
          <div class="mt-2" role="group">
            <button i18n id="sendMsgButton" class="btn btn-primary" (click)="sendMessage(messageInput, messageInputResponseDelay, messageSize)">Send</button>
            <button i18n id="restartWsButton" class="ms-2 btn btn-primary" (click)="restartWs()">Bounce</button>
          </div>
        </div>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Debug">
      <ng-template pTemplate="content">
        <div class="tabcontent wide">
          <label for="logLevel">Developer Console Logger Level</label>
          <p-dropdown appDd #lvl
            [options]="[{label:'Trace', value:0},{label:'Debug', value:1},{label:'Info', value:2},{label:'Log', value:3},{label:'Warn', value:4},{label:'Fatal', value:5},{label:'Error', value:6},{label:'Off', value:7} ]"
            [(ngModel)]="logLevel" appendTo="body" name="logLevel" id="logLevel" (onChange)="setLevel($event)">
          </p-dropdown>


          <label for="fmd" class="mt-3">When selected, debugging information is displayed under each field to help with error message and required state debugging.</label>
          <p-checkbox id="fmd" label="Field Message Debug" [binary]="true" [(ngModel)]="inlineMessageDebugChecked" (onChange)="onInlineMessageChange()"></p-checkbox>
        </div>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="TN Formatter" style="min-width: 500; min-height: 500;">
      <ng-template pTemplate="content">
        <div class="tabcontent wide">
          <div>Format TNs using the 3rd party formatting library.</div>
          <div class="row">
            <div class="col-6">
              <input appScrText placeholder="Phone Number" #tnInput>
              <input appScrText maxLength="2" placeholder="Country Code" type="text" #tnCountry>
              <div class="mt-2 btn-group" role="group">
                <button i18n id="formatButton" class="btn btn-primary" (click)="formatTn(tnInput, tnCountry)">Format</button>
              </div>
            </div>
            <div class="col-6">
              <pre>{{tnOutput}}</pre>
            </div>
          </div>
        </div>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="Cart Storage" style="min-width: 500; min-height: 500;">
      <ng-template pTemplate="content">

        <div class="tabcontent wide">
          <label for="mbcontent">Show and save marketing brochure content.</label>
          <textarea appScrText [(ngModel)]="mbText" class="d-block" id="mbcontent" rows="5" cols="60" #mbTextArea></textarea>
          <div class="mt-2" role="group">
            <button i18n id="saveButton" class="btn btn-primary" (click)="saveMbContent(mbTextArea)">Save</button>
            <button i18n id="refreshButton" class="ms-1 btn btn-primary" (click)="refreshMbContent()">Refresh</button>
          </div>
        </div>
      </ng-template>
    </p-tabPanel>

    <p-tabPanel header="Authentication" style="min-width: 500; min-height: 500;">
      <ng-template pTemplate="content">
        <div class="tabcontent wide">

          @if (!signedIn) {
          Cannot display tokens - not signed into app.
          }
          @else {
          Need to invoke an API in Postman? Set an Authentication header as follows:
          <div class="row">
            <div class="col-10">
              <textarea disabled wrap style="width: 100%">{{idToken}}</textarea>
            </div>
          </div>
          <div>
            <span>ID Token (Expires: {{idTokenExpiration}}):</span>
            <textarea disabled wrap style="width: 100%; height: 200px">{{parsedIdToken}}</textarea>
          </div>
          @if (refreshToken) {
          <div>
            <span>Refresh Token:</span>
            <textarea disabled wrap style="width: 100%; height: 200px">{{refreshToken}}</textarea>
          </div>
          }
          @if (accessToken) {
          <div>
            <span>Access Token:</span>
            <textarea disabled wrap style="width: 100%; height: 200px">{{accessToken}}</textarea>
          </div>
          }

          }
        </div>

      </ng-template>
    </p-tabPanel>

    @if (experiments) {
    <p-tabPanel header="GTM" style="min-width: 500; min-height: 500;">
      <ng-template pTemplate="content">
        <div class="tabcontent wide">
          <button class="btn btn-primary" (click)="gtmLogin()">Login</button>
          <button class="btn btn-primary" (click)="gtmPayment()">Pay</button>
        </div>
      </ng-template>
    </p-tabPanel>
    }


  </p-tabView>
  <p-footer>
    <button i18n id="ok" class="btn btn-primary" (click)="displayDialog = false;">OK</button>

  </p-footer>
</p-dialog>